import React from "react";
import Box from "@cloudscape-design/components/box";
import Select from "@cloudscape-design/components/select";
import SpaceBetween from "@cloudscape-design/components/space-between";

const noneOption = { value: null, label: "None" };

const formatStepLabel = (step) => {
	const rewardType = step.rewardType === "freespins" || step.rewardType === "both" ? step.rewardType : "deposit";
	const rewards = [];

	if (rewardType !== "freespins") rewards.push(`+${step.bonusPercent}%`);
	if (rewardType !== "deposit") {
		const spinsCount = (Array.isArray(step.fsParts) ? step.fsParts : []).reduce((total, part) => total + (Number(part?.spinsCount) || 0), 0);
		rewards.push(`+${spinsCount} FS`);
	}

	return `Deposit ${step.depositNumber} — ${rewards.join(", ")}`;
};

export default function DepositLadderBannerFields({ ladders, loading, ladderId, step, onChange }) {
	const ladderOptions = [
		noneOption,
		...ladders.map((ladder) => ({
			value: ladder.id,
			label: ladder.name,
			description: `ID: ${ladder.id} | ${ladder.mode} | ${Number(ladder.active) ? "Enabled" : "Disabled"}`,
		})),
	];
	const selectedLadder = ladders.find((ladder) => Number(ladder.id) === Number(ladderId));
	const stepOptions = (selectedLadder?.steps || []).map((item) => ({
		value: item.depositNumber,
		label: formatStepLabel(item),
	}));

	return (
		<SpaceBetween direction="vertical" size="m">
			<Box variant="span">Deposit Ladder</Box>
			<Select
				filteringType="auto"
				statusType={loading ? "loading" : "finished"}
				loadingText="Loading deposit ladders"
				placeholder="Select deposit ladder"
				selectedOption={ladderOptions.find((option) => Number(option.value) === Number(ladderId)) || noneOption}
				options={ladderOptions}
				onChange={({ detail }) => onChange(detail.selectedOption.value, null)}
			/>
			<Box variant="span">Deposit Ladder Step</Box>
			<Select
				disabled={!selectedLadder}
				placeholder={selectedLadder ? "Select deposit ladder step" : "Select deposit ladder first"}
				selectedOption={stepOptions.find((option) => Number(option.value) === Number(step)) || null}
				options={stepOptions}
				onChange={({ detail }) => onChange(selectedLadder.id, detail.selectedOption.value)}
			/>
		</SpaceBetween>
	);
}
